export default __webpack_public_path__ + "static/media/dphns_small_thumbnail_website_8.b2c824ea.jpg";